import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import SimplePopperPopover from '@wix/da-ds/pkg/popper/presets/SimplePopperPopover';
import s from './Dots.scss';
var Dots = function (_a) {
    var pageSize = _a.pageSize, totalPages = _a.totalPages, onChangePage = _a.onChangePage, getPageUrl = _a.getPageUrl, _b = _a.startOpen, startOpen = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var logBiEvent = useBiLogger();
    var _c = useState(startOpen), showPopover = _c[0], setShowPopover = _c[1];
    var _d = useState(), pageNumber = _d[0], setPageNumber = _d[1];
    var isValidPage = !!pageNumber && pageNumber > 0 && pageNumber <= totalPages;
    var onInputChange = function (ev) {
        var value = ev.target.value;
        if (value === '' || value === undefined) {
            setPageNumber(undefined);
            return;
        }
        var number = parseInt(value, 10);
        if (!Number.isNaN(number)) {
            setPageNumber(number);
        }
    };
    var closePopover = useCallback(function () { return setShowPopover(false); }, []);
    var onKeyDown = useCallback(function (e) {
        if (e.key === 'Enter') {
            setShowPopover(false);
            onChangePage && onChangePage(pageNumber);
            if (getPageUrl) {
                var url = getPageUrl(pageNumber);
                if (url) {
                    logBiEvent({
                        evid: BiEventType.PAGE_NAVIGATION_CLICK,
                        direction: pageNumber,
                        thumbs_per_page: pageSize,
                    });
                    window.location.assign(url);
                }
            }
        }
    }, [getPageUrl, onChangePage, pageNumber, pageSize, logBiEvent]);
    return (React.createElement(SimplePopperPopover, { className: s['wrapper'], isVisible: showPopover, contentClassName: s['jump-panel'], showArrow: false, forceTheme: ThemeOptions.DARK, placement: "bottom", onClickOutside: closePopover, popoverContent: React.createElement(React.Fragment, null,
            React.createElement("div", { className: s['goto'] }, t('pagination.goToPage')),
            React.createElement(TextInput, { id: "pagination-goto-page-input", value: pageNumber ? "".concat(pageNumber) : '', onChange: onInputChange, onKeyDown: isValidPage ? onKeyDown : undefined, className: s['input'], label: t('pagination.goToPage'), isLabelHidden: true, autoFocus: true })) },
        React.createElement("button", { className: classnames(s['dots'], showPopover && s['open']), onClick: function () { return setShowPopover(function (show) { return !show; }); } }, "...")));
};
Dots.displayName = 'Dots';
export default Dots;
//# sourceMappingURL=Dots.js.map